import { useCallback, useContext } from "react";
import { useRouter } from "@tanstack/react-router";
import { DashboardContext } from "@/components/dashboard-layout";
import { handleCloseParam } from "@/components/close-rightsidebar";
import { closeFullscreenDialog } from "@/components/fullscreen-sidebar";

export function useRightSidebarClose() {
  const dashboardContext = useContext(DashboardContext);
  const { navigate } = useRouter();

  return useCallback(
    (paramToRemove?: string | string[]) => {
      closeFullscreenDialog();

      handleCloseParam({
        paramToRemove,
        setSidebar: dashboardContext?.setRightSidebar ?? (() => {}),
        navigate,
      });
    },
    [dashboardContext?.setRightSidebar, navigate]
  );
}
